<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'form-group',
    props: ['name']
  }
</script>
